export const getColumns = () => {
  return [
    {
      'Header': 'MASTER',
      'accessor': 'masterCode',
      'width': 4,
    },
    {
      'Header': 'SEGMENTO',
      'accessor': 'suffix',
      'width': 2,
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'carModel',
      'width': 8,
    },
  ];
};
